import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseClientUserExternalTokensProps<T> = {
  filters: {
    clientUserId?: string;
    page?: number;
    search?: string;
  },
  mapper?: (data: any) => T;
};

const useClientUserExternalTokens = <T,>({
  filters: { page, search, clientUserId },
  mapper = Mapper.default<T>(),
}: UseClientUserExternalTokensProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    enabled: !!clientUserId,
    queryKey: ['clientUserExtenalTokens', clientUserId],
    queryFn: () => {
      return privateAxios.get(`/client/user_external_tokens`, {
        params: {
          search,
          page,
          "q[user_id_eq]": clientUserId,
        },
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, isPending, ...rest };
};

export default useClientUserExternalTokens;
